import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
function CenteredWrapper({ children, ...rest }) {
  return (
    <Box
      width="100%"
      maxWidth="1440px"
      margin="0 auto"
      paddingX={{ base: '24px', md: '32px', lg: '40px' }}
      {...rest}
    >
      {children}
    </Box>
  );
}

CenteredWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CenteredWrapper;
